export default "__VITE_ASSET__obx7DPCd__"